/** Must match backend/src/utils/permissions.ts. */
export const AUDIT_LOG_READ_PERMISSION = 'audit_log:read';
